export enum EditedInvoicesStatusEnum {
  IMPORT = 'Import',
  INVOICES = 'Factures',
}
